<template>
  <div class="light-add-dialog">
    <el-form
      :model="editOne"
      :rules="editOneRule"
      ref="dialogRef"
      label-width="120px"
    >
      <el-row :gutter="20" class="item-list">
        <el-col :span="12">
          <el-form-item :label="$t('device.select_protocol')">
            <el-select
              :placeholder="$t('device.select_protocol')"
              v-model="editOne.lamp_type"
              style="width: 100%"
            >
              <el-option
                v-for="(t,index) in lampTypeList"
                v-if="index !== 0"
                :key="index"
                :label="t"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.device_number')" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('device.device_name')" prop="name">
            <el-input v-model="editOne.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('device.single_Double')">
            <el-select
              :placeholder="$t('device.select_single_Double')"
              v-model="editOne.is_double"
              style="width: 100%"
            >
              <el-option
                v-for="(t,index) in doubleType"
                :key="index"
                :label="t"
                :value="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="editOne.lamp_type==4" :label="$t('device.gateway_number')"> 
            <el-input v-model="editOne.gateway"></el-input>
          </el-form-item>
          <el-form-item :label="$t('device.group')"> 
            <el-select
              :placeholder="$t('device.select_group')"
              v-model="editOne.lamp_group"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="t in lampGroupList"
                :key="t.id"
                :label="t.name"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.strategy')">
            <el-select
              :placeholder="$t('device.select_strategy')"
              v-model="editOne.stg_id"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="t in strategyList"
                :key="t.id"
                :label="t.title"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.project')">
            <el-select
              clearable
              filterable
              :placeholder="$t('device.select_project')"
              v-model="editOne.project_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in projectList"
                :key="t.project_id"
                :label="t.project_name"
                :value="t.project_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.is_home')">
            <div class="checkbox-item">
              <el-checkbox v-model="editOne.is_display" :true-label="1" :false-label="0"></el-checkbox>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="20" class="item-list">
            <el-col :span="24">
              <div v-if="editOne.longitude&&editOne.latitude" class="map-box">
                <amap :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
              </div>
              <div class="h20"></div>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('control.longitude')" class="lnglat-input">
                <el-input v-model="editOne.longitude" @input="onInput()" style="width: 100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('control.latitude')" class="lnglat-input">
                <el-input v-model="editOne.latitude" @input="onInput()" style="width: 100%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('device.is_sensor')" class="r-label">
                <div class="checkbox-item">
                  <el-checkbox v-model="editOne.is_sensor" :true-label="1" :false-label="0"></el-checkbox>
                </div>
              </el-form-item>
            </el-col>
            
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <div class="button-footer">
      <el-button
      size="medium"
      class="cancel-btn"
      @click="handleClose"
      >{{$t('control.cancel')}}</el-button >

      <el-button
        type="primary"
        size="medium"
        @click="createItem"
        v-if="editType === 'create'"
        >{{$t('control.confirm')}}</el-button>
      <el-button
        type="primary"
        size="medium"
        @click="updateItem"
        v-if="editType === 'update'"
        >{{$t('control.confirm')}}</el-button>
      </div>
  </div>
</template>
<script>
import lampsApi from "@/api/device/lamps";
import lampGroupApi from "@/api/device/lampGroup";
import strategyApi from "@/api/device/strategy";
import projectApi from "@/api/system/project";
import amap from '@/components/addMap'
export default {
  name: "mapAddLamp",
  components: {
    amap
  },
  props: {
    editType: {
      type: String,
    },
    position: {
      type: Array
    }
  },
  data() {
    return {
      editOneRule: {
        name: [{ required: true, message: this.$t('device.please_device_name'), trigger: "blur" }],
        number: [{ required: true, message: this.$t('device.please_device_number'), trigger: "blur" }],
      },
      editOne: {
        lamp_type: 1,
        project_id: '',
        number: '',
        name: '',
        is_double: 0,
        lamp_group: '',
        stg_id: '',
        longitude: '',
        latitude: '',
        gateway: '',
        is_display: 1,
        is_sensor: 0
      },
      lampTypeList: this.$t('device.lampTypeList'),
      doubleType: this.$t('device.doubleType'),
      projectList: [],
      strategyList: [],
      lampGroupList: [],
    };
  },
  watch: {
    editType: {
      handler: function(newVal) {
        if (newVal.lng && newVal.lat) {
          this.openEditWin(this.editType)
        }
      }
    }
  },
  methods: {
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          lamp_type: 1,
          project_id: '',
          number: '',
          name: '',
          is_double: 0,
          lamp_group: '',
          stg_id: '',
          longitude: '',
          latitude: '',
          gateway: '',
          is_display: 1,
          is_sensor: 0
        };
        [this.editOne.longitude, this.editOne.latitude] = this.position
        this.editType = "create"
      }
    },
    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          lampsApi.lightEdit(this.editOne.lamp_id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'))
              this.handleClose()
            } else {
              this.$message.error(res.data.message)
            }
          });
        }
      });
      
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          lampsApi.lightAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'))
              this.handleClose()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
      
    },
    getProjectList() {
      projectApi.getProject({
        sortBy: 'project_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data
        this.projectList = resData.list
      });
    },
    getLampGroupList() {
      lampGroupApi.lampGroupList({
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data;
        this.lampGroupList = resData.list;
      });
    },
    getStrategyList() {
      // console.log('getStrategyList')
      strategyApi.strategyList({
        page: 1,
        pageSize: 500
      }).then((res) => {
        const resData = res.data.data
        this.strategyList = resData.list
      });
    },
    handleClose() {
      this.$emit('closeMethod')
    },
    getCoordinate(map) {
      // console.log('getCoordinate', map)
      this.editOne.longitude = map.lng
      this.editOne.latitude = map.lat
    },
    onInput() {
      this.$forceUpdate();
    },
  },
  mounted() {
    this.getProjectList()
    this.getLampGroupList()
    this.getStrategyList()
    this.openEditWin(this.editType)
  },
};
</script>
<style lang='less' scoped>
.light-add-dialog{
  width: 100%;
  .table-head{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 20px;
    margin-top: -60px;
  }
}
</style>
<style lang="less">
.light-add-dialog{
  .lnglat-input{
    .el-form-item__label{
      width:80px !important
    }
    .el-form-item__content{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .el-input--mini{
        width:48%;
      }
      &::after, &::before{
        display: none;
      }
    }
  }

  .map-box{
    padding:0 13px;
    height: 330px;
    overflow: hidden;
  }
  .r-label{
    .el-form-item__label{
      width: 172px !important;
    }
  }
}
</style>